// src/components/messaging/ConversationItem.tsx
import React from 'react';
import { Conversation } from '../../types/message';
import Avatar from '../common/Avatar';

interface ConversationItemProps {
  conversation: Conversation;
  isActive: boolean;
  onClick: () => void;
  lastMessageTime: string;
}

const ConversationItem: React.FC<ConversationItemProps> = ({
  conversation,
  isActive,
  onClick,
  lastMessageTime
}) => {
  const truncateMessage = (message: string, maxLength: number = 50) => {
    if (message.length <= maxLength) return message;
    return message.substring(0, maxLength) + '...';
  };

  return (
    <div
      onClick={onClick}
      className={`p-4 cursor-pointer transition-all ${
        isActive 
          ? 'bg-white border-2 border-coffee rounded-lg shadow-[2px_2px_0px_#594A42] -translate-y-0.5 mx-2 my-1' 
          : 'hover:bg-coffee/5'
      }`}
    >
      <div className="flex items-center space-x-3">
        {/* Avatar */}
        <div className="relative">
          <Avatar
            profilePictureUrl={conversation.participant.profilePicture ?? null}
            firstName={conversation.participant.firstName}
            lastName={conversation.participant.lastName}
            userId={conversation.participant.id}
            size="small"
          />
          {conversation.participant.isOnline && (
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-cream"></div>
          )}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h3 className="text-coffee font-bold text-sm truncate">
              {conversation.participant.firstName} {conversation.participant.lastName}
            </h3>
            <span className="text-coffee/60 text-xs">
              {lastMessageTime}
            </span>
          </div>
          
          <div className="flex items-center justify-between">
            <p className="text-coffee/70 text-sm truncate">
              {conversation.lastMessage ? 
                truncateMessage(conversation.lastMessage.content) : 
                'No messages yet'
              }
            </p>
            
            {conversation.unreadCount > 0 && (
              <div className="bg-terracotta text-white font-bold border border-coffee text-xs rounded-full w-5 h-5 flex items-center justify-center ml-2">
                {conversation.unreadCount > 9 ? '9+' : conversation.unreadCount}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationItem;